import "./input_drop_box.css";

function InputDropBox({ label, id, options, placeholder = "Selecione", className = "", value, ...props }) {
    const isControlled = value !== undefined;
    const selectProps = { ...props };

    if (isControlled) {
        selectProps.value = value;
    } else {
        selectProps.defaultValue = "";
    }

    return (
        <div className={`input-drop-box-container ${className}`}>
            {label && <label htmlFor={id}>{label}</label>}
            <select id={id} className="select-input" {...selectProps}>
                <option value="" disabled>{placeholder}</option>
                {options.map((option, index) => (
                    <option key={index} value={option.value || option}>
                        {option.label || option}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default InputDropBox;
